export default "__VITE_ASSET__D6r60y8w__"